export default "__VITE_ASSET__Q0ce1cJM__"